import { useMutation } from '@tanstack/react-query';
import React from 'react';

import { analytics } from 'analytics';
import { VStack } from 'ui/Layout';
import Link from 'ui/Link';
import Spinner from 'ui/Spinner';
import { Text } from 'ui/Typography';

import { useApiContext } from '../../contexts/apiContext';
import { useCurrentUser } from '../../utils/user';

const AddinHomePageFooter: React.FC = () => {
  const { api } = useApiContext();
  const { user, refetchUser } = useCurrentUser();

  const { mutateAsync: signOut, isLoading } = useMutation(async () => {
    try {
      await api().currentUser.signOut();
      await refetchUser();
    } catch (error) {
      analytics.reportError('Error signing out', { error });
    }
  });

  return (
    <VStack w="100vw" alignItems="center" fontSize="sm" pb={4} mt={8}>
      <Text textAlign="center">
        You are signed in as <strong>{user?.email}</strong>
      </Text>
      {isLoading ? (
        <Spinner size="sm" />
      ) : (
        <Link onClick={() => signOut()}>Sign out</Link>
      )}
    </VStack>
  );
};

export default AddinHomePageFooter;
